export enum VoteAction {
  VotesLoaded,
  VoteDeleted,
  VoteAdded
}
